<template>
    <div class="page-table projeTanim mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.projeler.guncelleme.pageBaslik")}}
        </div>
        <el-row :gutter="10">
            <el-form status-icon :model="projelerForm" :rules="rulesProjeler" ref="projelerForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item
                                        :label='$t("src.views.apps.projeler.tanimlama.baslik")'
                                        prop="baslik">:
                                    <div v-if="linkVisible" style="float: right; display: flex">
                                        <div v-if="!VisibleA">
                                            <el-link target="_blank" :underline="false"
                                                     :href="this.path">
                                                {{this.path}}{{this.projelerForm.link}}
                                            </el-link>
                                        </div>
                                        <el-button v-if="duzenleBtnVisible"
                                                   style="margin-left: 10px; margin-bottom: 5px"
                                                   v-on:click="VisibleA = true; duzenleBtnVisible=false"
                                                   size="mini">Düzenle
                                        </el-button>
                                        <span v-if="VisibleA">{{this.path}} </span>
                                        <el-input v-if="VisibleA" v-model="projelerForm.link"
                                                  v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                  v-on:change="linkChange = false;$store.commit('changeTabsClose', false)"
                                                  style="width: 50%" size="mini"></el-input>
                                    </div>
                                    <el-input
                                            v-model="projelerForm.baslik"
                                            v-on:change="linkTespit();$store.commit('changeTabsClose', false)"
                                            :placeholder='$t("src.views.apps.projeler.tanimlama.baslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.projeler.tanimlama.altbaslik")'
                                              prop="altBaslik">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"
                                            v-model="projelerForm.altBaslik"
                                            :placeholder='$t("src.views.apps.projeler.tanimlama.altBaslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.projeler.tanimlama.icerik")'
                                              prop="icerik">:
                                    <div>
                                        <ckeditor :editor="editor" :config="editorConfig"
                                                  @input="seoIcerikTespit(); $store.commit('changeTabsClose', false)"
                                                  @blur="seoIcerikTespit(); $store.commit('changeTabsClose', false)"
                                                  v-model="projelerForm.icerik"></ckeditor>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                        <draggable
                                data-source="juju"
                                class="list-group"
                                group="a">
                            <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="7">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.projeler.tanimlama.resim")'
                                                      prop="resim">:
                                            <el-upload
                                                    class="resimler"
                                                    action=""
                                                    list-type="picture-card"
                                                    multiple
                                                    :file-list="imageListMain"
                                                    :auto-upload="false"
                                                    accept=".jpg,.jpeg,.png"
                                                    :on-change="imageUpload"
                                                    :on-preview="firstImage"
                                                    :on-remove="imageRemove">
                                                <i slot="default" class="el-icon-plus"></i>
                                            </el-upload>
                                            <el-button style="margin-top: 15px" type="primary"
                                                       v-on:click="serverImageList"
                                                       @click="dialogServerVisible = true; " size="mini">
                                                Sunucudan
                                                Seç
                                            </el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium" title="Belge Ayarları" name="8">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.projeler.tanimlama.belge")'
                                                      prop="belge">:
                                            <el-row>
                                                <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                                    <el-upload
                                                            class="upload-demo"
                                                            action=""
                                                            accept=".pdf,.doc,.docx,.xls,.xlsx"
                                                            :file-list="fileListMain"
                                                            :auto-upload="false"
                                                            :on-change="fileUpload"
                                                            :on-remove="fileRemove">
                                                        <el-button size="mini" style="width: 150px;"
                                                                   type="success">
                                                            Dosya
                                                            Yükle
                                                        </el-button>
                                                    </el-upload>
                                                    <el-button style="margin-top: 15px;width: 150px;"
                                                               type="primary"
                                                               v-on:click="serverDocumentList"
                                                               @click="dialogDocServerVisible = true; "
                                                               size="mini">
                                                        Sunucudan
                                                        Seç
                                                    </el-button>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="9">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                      prop="seoBaslik">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      v-model="projelerForm.seoBaslik"
                                                      maxlength="60"
                                                      show-word-limit
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                      prop="seoIcerik">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      type="textarea"
                                                      v-on:focus="seoicerikChange = false"
                                                      maxlength="140"
                                                      show-word-limit
                                                      v-model="projelerForm.seoIcerik"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item class="card-shadow--medium" name="1"
                                          :title='$t("src.views.apps.projeler.tanimlama.durum")'>
                            <el-row>
                                <el-button
                                        style="margin-bottom: 10px"
                                        size="mini" v-on:click="projeGuncelle('projelerForm')"
                                        class="onayBtn"
                                        type="primary">
                                    {{$t('src.views.apps.projeler.guncelleme.projeGuncelle')}}
                                </el-button>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.projeler.tanimlama.kategori")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="kategori">
                                            <el-select
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="projelerForm.pkategoriKodu"
                                                    :placeholder='$t("src.views.apps.projeler.tanimlama.kategoriPlace")'
                                                    style="width: 100%">
                                                <el-option v-for="item in kategoriListe"
                                                           :key="item.pkategoriKodu"
                                                           :label="item.baslik"
                                                           :value="item.pkategoriKodu"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-tag style="margin-bottom: 10px"
                                                :key="tag"
                                                v-for="tag in dynamicTags"
                                                closable
                                                :disable-transitions="false"
                                                @close="webSiteRemove(tag)">
                                            {{tag}}
                                        </el-tag>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.projeler.tanimlama.resimKonum")' name="3">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="resimKonum">
                                            <el-button type="primary" size="mini" @click="drawerResimKonum = true">
                                                {{this.btnResim}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="projelerForm.resimKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="60%" height="60%">
                                            <img v-if="projelerForm.resimKonum === '1'" style="float: right"
                                                 src="../../../assets/images/2.png" width="60%" height="60%">
                                            <img v-if="projelerForm.resimKonum === '2'" style="float: right"
                                                 src="../../../assets/images/5.png" width="60%" height="60%">
                                            <img v-if="projelerForm.resimKonum === '3'" style="float: right"
                                                 src="../../../assets/images/4.png" width="60%" height="60%">
                                            <img v-if="projelerForm.resimKonum === '4'" style="float: right"
                                                 src="../../../assets/images/3.png" width="60%" height="60%">
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.projeler.tanimlama.menuKonum")' name="4">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="menuKonum">
                                            <el-button type="primary" size="mini" @click="drawerMenuKonum = true">
                                                {{this.btnMenu}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="projelerForm.menuKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="60%" height="60%">
                                            <img v-if="projelerForm.menuKonum === '1'" style="float: right"
                                                 src="../../../assets/images/6.png" width="60%" height="60%">
                                            <img v-if="projelerForm.menuKonum === '2'" style="float: right"
                                                 src="../../../assets/images/9.png" width="60%" height="60%">
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.projeler.tanimlama.galeriKonum")' name="5">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="galeriKonum">
                                            <el-button type="primary" size="mini" @click="drawerGaleriKonum = true">
                                                {{this.btnGaleri}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="projelerForm.galeriKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="60%" height="60%">
                                            <img v-if="projelerForm.galeriKonum === '1'" style="float: right"
                                                 src="../../../assets/images/7.png" width="60%" height="60%">
                                            <img v-if="projelerForm.galeriKonum === '2'" style="float: right"
                                                 src="../../../assets/images/8.png" width="60%" height="60%">
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.projeler.tanimlama.tarih")' name="6">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.projeler.tanimlama.tarih")'
                                                      prop="baslamaTarihi">:
                                            <el-date-picker class="select-wide" type="datetime"
                                                            :placeholder='$t("src.views.apps.projeler.tanimlama.tarihPlace")'
                                                            :picker-options="dateRangeOptions"
                                                            v-model="projelerForm.baslamaTarihi"
                                                            format="yyyy-MM-dd HH:mm:ss"
                                                            value-format="yyyy-MM-dd HH:mm:ss">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-checkbox style="margin-bottom: 20px" v-model="checked">
                                            {{$t("src.views.apps.projeler.tanimlama.bitisTarihi")}}
                                        </el-checkbox>
                                        <el-col v-if="checked" :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.projeler.tanimlama.bitisTarihi")'
                                                          prop="bitisTarihi">:
                                                <el-date-picker class="select-wide" type="datetime"
                                                                :placeholder='$t("src.views.apps.projeler.tanimlama.bitisTarihiPlace")'
                                                                :picker-options="dateRangeOptions"
                                                                v-model="projelerForm.bitisTarihi"
                                                                format="yyyy-MM-dd HH:mm:ss"
                                                                value-format="yyyy-MM-dd HH:mm:ss">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.projeler.tanimlama.sayac")' name="10">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.projeler.tanimlama.sayac")'
                                                      prop="sayac">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      v-mask="'######'"
                                                      v-model="projelerForm.sayac"></el-input>
                                        </el-form-item>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24">
                                            <el-form-item :label='$t("src.views.apps.projeler.tanimlama.begen")'
                                                          prop="begen">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                          v-mask="'######'"
                                                          v-model="projelerForm.begen"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        list-type="picture-card"
                        :on-change="serverImageUpload"
                        accept=".jpg,.jpeg,.png"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-delete"
                                                  @click="imageUploadtoServer(file)">
                                                    <i class="el-icon-plus"></i>
                                            </span>
                                        </span>
                    </div>
                </el-upload>
            </el-dialog>
            <el-dialog
                    title='Sunucudan Belge Seç'
                    :visible.sync="dialogDocServerVisible"
                    width="50%"
                    center>
                <el-upload
                        action="#"
                        accept=".pdf,.doc,.docx,.xls,.xlsx"
                        class="upload-demo"
                        :on-preview="fileUploadtoServer"
                        :auto-upload="false"
                        :file-list="fileListServer">
                </el-upload>
            </el-dialog>
            <el-dialog
                    title="Resim Konumu"
                    :visible.sync="drawerResimKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.resimKonum" label="0" @change="changeKonum('resim','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.resimKonum" label="1" @change="changeKonum('resim','1')">
                            <img src="../../../assets/images/2.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.resimKonum" label="2" @change="changeKonum('resim','2')">
                            <img src="../../../assets/images/5.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.resimKonum" label="3" @change="changeKonum('resim','3')">
                            <img src="../../../assets/images/4.png" alt="Sol" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.resimKonum" label="4" @change="changeKonum('resim','4')">
                            <img src="../../../assets/images/3.png" alt="Üst" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Menü Konumu"
                    :visible.sync="drawerMenuKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.menuKonum" label="0" @change="changeKonum('menu','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.menuKonum" label="1" @change="changeKonum('menu','1')">
                            <img src="../../../assets/images/6.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.menuKonum" label="2" @change="changeKonum('menu','2')">
                            <img src="../../../assets/images/9.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Galeri Konumu"
                    :visible.sync="drawerGaleriKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.galeriKonum" label="0" @change="changeKonum('galeri','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.galeriKonum" label="1" @change="changeKonum('galeri','1')">
                            <img src="../../../assets/images/7.png" alt="Dikey,Büyük" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="projelerForm.galeriKonum" label="2" @change="changeKonum('galeri','2')">
                            <img src="../../../assets/images/8.png" alt="Yatay,Küçük" width="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import draggable from "vuedraggable";

    let $ = JQuery;
    import seoService from '../../../WSProvider/SeoService'
    import projeService from '../../../WSProvider/ProjeService'
    import controllerService from '../../../WSProvider/ControllerService'
    import projeKategoriService from '../../../WSProvider/ProjeKategoriService'
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataSidas = "";
    export default {
        name: "ProjelerDuzenle",
        components: {
            draggable
        },
        props: {
            language: {
                type: String,
                describe: 'en'
            }
        },
        mounted() {
            this.getKategoriListe();
            this.updateProjeKodu = this.$store.state.updateKodu;
            this.getProjeDetay(this.updateProjeKodu);
        },
        data() {
            return {
                drawerResimKonum: false,
                drawerMenuKonum: false,
                drawerGaleriKonum: false,
                path: projeService.path,
                dialogDocServerVisible: false,

                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                btnResim: "Seç",
                btnMenu: "Seç",
                btnGaleri: "Seç",
                dynamicTags: [],
                imageListMain: [],
                fileListMain: [],
                fileListServer: [],
                imageListServer: [],
                seoicerikChange: true,
                seoicerikDilChange: true,
                VisibleA: false,
                duzenleBtnVisible: true,
                dialogServerVisible: false,
                linkVisible: false,
                linkChange: true,
                projeDetayListKlon: [],
                updateData: [],
                updateDataEN: [],
                checked: '',
                kategoriListe: [],
                updateProjeKodu: '',
                projelerForm: {
                    pkategoriKodu: '',
                    baslik: '',
                    link: '',
                    altBaslik: '',
                    icerik: '',
                    resim: [],
                    resimKonum: '',
                    menuKonum: '',
                    galeriKonum: '',
                    kaynakca: '',
                    webSite: [],
                    baslamaTarihi: '',
                    bitisTarihi: '',
                    durum: '',
                    sayac: '',
                    begen: '',
                    seoBaslik: '',
                    seoBaslikDil: '',
                    seoIcerikDil: '',
                    seoIcerik: '',
                },
                dateRangeOptions: {
                    firstDayOfWeek: 1
                },
                rulesProjeler: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Proje Başlığı Giriniz",
                        trigger: 'blur'
                    }]
                },
            }
        },
        methods: {

            getKategoriListe() {
                projeKategoriService.kategoriList(0).then(response => {
                    if (response.status === 200) {
                        if (response.data.length === 0) {
                            notification.Status('warning', this, 'Kategori listesi boş! Lütfen önce kategori tanımlayınız.');
                            this.disabled = true;
                        } else {
                            this.kategoriListe = response.data;
                        }
                        if (response.data.length > 0) {
                            this.projelerForm.pkategoriKodu = response.data[0].pkategoriKodu;
                        }
                    } else {
                        notification.Status(notification.status, this)
                    }
                })
            },
            seoIcerikTespit() {
                if (this.seoicerikChange) {
                    const myStr = strip_html_tags(this.projelerForm.icerik);
                    this.projelerForm.seoIcerik = myStr.substring(0, 140);
                }
            },
            linkTespitLink() {
                let self = this;
                if (this.projelerForm.link) {
                    seoService.linkKontrol(self.projelerForm.link.replace("'", "").substring(0, 60)).then((response) => {
                        if (response.status === 200) {
                            self.projelerForm.link = response.data;
                        } else {
                            notification.Status(notification.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.projelerForm.baslik && this.linkChange) {
                    seoService.linkKontrol(this.projelerForm.baslik.replace("'", "").substring(0, 60)).then((response) => {
                        if (self.projelerForm.baslik) {
                            self.projelerForm.seoBaslik = self.projelerForm.baslik.substring(0, 60);
                            if (response.status === 200) {
                                self.linkVisible = true;
                                self.projelerForm.link = response.data;
                            }
                        } else if (!self.projelerForm.baslik) {
                            self.linkVisible = false;
                            self.projelerForm.link = '';
                            self.projelerForm.seobaslik = '';
                        }
                    })
                }
            },
            getProjeDetay(projeKodu) {
                let self = this;
                projeService.projeDetay(projeKodu).then((response) => {
                    if (response.status === 200) {
                        if (response.data.anaResim) {
                            self.imageListMain.push({
                                name: response.data.anaResim,
                                url: projeService.imageUrlOrta + response.data.anaResim
                            });
                        }
                        if (response.data['resim']) {
                            response.data['resim'].forEach(function (e) {
                                if (e) {
                                    self.imageListMain.push({
                                        name: e,
                                        url: projeService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        if (response.data['belge']) {
                            response.data['belge'].forEach(function (e) {
                                if (e) {
                                    self.fileListMain.push({
                                        name: e,
                                        url: projeService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        self.projelerForm.pkategoriKodu = response.data.pkategoriKodu;
                        self.projelerForm.baslik = response.data.baslik;
                        self.linkVisible = true;
                        self.projelerForm.link = response.data.link;
                        self.projelerForm.altBaslik = response.data.altBaslik;
                        if (response.data.icerik) {
                            self.projelerForm.icerik = htmlDecode(response.data.icerik);
                        }
                        self.projelerForm.resimKonum = response.data.resimKonum;
                        self.projelerForm.menuKonum = response.data.menuKonum;
                        self.projelerForm.galeriKonum = response.data.galeriKonum;
                        self.projelerForm.baslamaTarihi = response.data.baslamaTarihi;
                        if (response.data.bitisTarihi) {
                            self.projelerForm.bitisTarihi = response.data.bitisTarihi;
                            self.checked = true;
                        }
                        self.projelerForm.durum = response.data.durum;
                        self.projelerForm.sayac = response.data.sayac;
                        self.projelerForm.begen = response.data.begen;
                        self.projelerForm.seoBaslik = response.data.seoBaslik;
                        self.projelerForm.seoIcerik = response.data.seoIcerik;
                        self.projeDetayListKlon = response.data;
                    } else {
                        notification.Status(notification.status, this)
                    }
                })
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageList() {
                var dizi = [];
                projeService.sunucuResim('proje').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: projeService.imageUrlKucuk + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })

            },
            serverDocumentList() {
                var dizi = [];
                projeService.sunucuBelge('proje').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                            };
                            dizi.push(item);
                        });
                        this.fileListServer = dizi;
                    }
                })
            },
            fileUploadtoServer(file) {
                if (this.fileListMain.length === 0) {
                    var item = {
                        name: file.name.slice(file.name.indexOf("-") + 1),
                        url: file.url,
                    };
                    this.fileListMain.push(item);
                    updateList(this, 'belge', 1, file.name.slice(file.name.indexOf("-") + 1));
                    notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' belgesi eklendi.');
                } else {
                    let obj = this.fileListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                    if (obj === undefined) {
                        item = {
                            name: file.name.slice(file.name.indexOf("-") + 1),
                            url: file.url,
                        };
                        this.fileListMain.push(item);
                        updateList(this, 'belge', 1, file.name.slice(file.name.indexOf("-") + 1));
                        notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' belgesi eklendi.');
                    } else {
                        notification.Status('warning', this, 'Bu belge zaten mevcut');
                    }
                }
            },
            fileRemove(file) {
                this.fileListMain.splice(this.fileListMain.indexOf(file), 1);
                updateList(this, 'belge', 0, file.name);
            },
            fileUpload(file, fileList) {
                var type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                var typeExcel = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                if (file.raw["type"] === type || file.raw["type"] === typeExcel || file.raw["type"] === 'application/vnd.ms-excel' || file.raw["type"] === 'application/msword' || file.raw["type"] === 'application/pdf') {
                    var uzanti = (file.name.slice(file.name.lastIndexOf(".")));
                    var dosyaName = (file.name.split(file.name.slice(file.name.lastIndexOf(".")))[0]).substring(0, 60);
                    var imgname = randomText(7) + '-' + linkTemizle(dosyaName) + uzanti;
                    var item = {
                        name: imgname,
                        url: file.url,
                        id: file.raw.lastModified
                    };
                    this.fileListMain.push(item);
                    const files = file.raw;
                    if (files) {
                        const reader = new FileReader();
                        reader.onload = e => {
                            const data = e.target.result;
                            controllerService.belgeYukle('proje', imgname, data).then((response) => {
                                if (response.status === 200) {
                                    this.projelerForm.belge.push(response.data);
                                    updateList(this, 'belge', 1, response.data);
                                } else notification.Status(response.status, this);
                            });
                        }
                        reader.readAsDataURL(files);
                        updateList(this, 'belge', 1, imgname);
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".pdf", ".xls", "xlsx", ".doc" ve ".docx" uzantılı görsel seçiniz!!');
                }
            },
            imageUploadtoServer(file) {
                if (this.imageListMain.length === 0) {
                    var item = {
                        name: file.name.slice(file.name.indexOf("-") + 1),
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    updateList(this, 'resim', 1, file.name.slice(file.name.indexOf("-") + 1));
                    notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                } else {
                    let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                    if (obj === undefined) {
                        item = {
                            name: file.name.slice(file.name.indexOf("-") + 1),
                            url: file.url,
                        };
                        this.imageListMain.push(item);
                        updateList(this, 'resim', 1, file.name.slice(file.name.indexOf("-") + 1));
                        notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                }
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, randomText(7) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('proje',imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.projelerForm.resimKonum = '1';
                            }else notification.Status(response.status,this)
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.projelerForm.baslik) {
                        var imgname = randomText(7) + '-' + this.projelerForm.link + ".png";
                    } else {
                        imgname = randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                    }
                    if (this.imageListMain.length === 0) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.imageListMain.push(item);
                        this.sumResimFonk(file, imgname);
                        updateList(this, 'resim', 1, imgname);
                    } else {
                        let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                        if (obj === undefined) {
                            item = {
                                name: imgname,
                                url: file.url,
                                id: file.raw.lastModified
                            };
                            this.imageListMain.push(item);
                            this.sumResimFonk(file, imgname);
                            updateList(this, 'resim', 1, imgname);
                        } else {
                            notification.Status('warning', this, 'Bu resim zaten mevcut');
                        }
                    }
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
                updateList(this, 'resim', 0, file.name);
            },
            projeGuncelle(formName) {
                for (var key in this.projeDetayListKlon) {
                    if (key !== 'webSite' && key !== 'resim' && key !== 'belge') {
                        if (this.projeDetayListKlon[key] !== this.projelerForm[key]) {
                            if (this.projelerForm[key]) {
                                var item = {
                                    type: key,
                                    value: this.projelerForm[key]
                                };
                                this.updateData.push(item);
                            }
                        }
                    }
                }
                this.$refs[formName].validate((valid) => {
                    if (valid && this.updateData.length !== 0) {
                        projeService.projeGuncelleme(this.updateProjeKodu, this.updateData).then((response) => {
                            if (response.status === 200) {
                                this.resetForm(formName);
                                notification.Status('success', this, 'Proje başarıyla güncellendi.');
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir proje zaten mevcut');
                            } else {
                                notification.Status(notification.status, this)
                            }
                        });
                    } else
                        notification.Status('warning', this, 'Değişiklik yapılmadı!');
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                this.imageListMain = [];
                this.fileListMain = [];
                this.projelerForm.link = null;
                this.linkVisible = false;
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "ProjeDuzenle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "ProjeDuzenle") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            changeKonum(item, konum) {
                if (item === 'resim') {
                    this.drawerResimKonum = false;
                    this.btnResim = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Resim konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Resim konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Resim konumu "Alt" olarak seçildi.');
                            break;
                        case '3' :
                            notification.Status('success', this, 'Resim konumu "Sol" olarak seçildi.');
                            break;
                        case '4' :
                            notification.Status('success', this, 'Resim konumu "Üst" olarak seçildi.');
                            break;
                    }
                } else if (item === 'menu') {
                    this.drawerMenuKonum = false;
                    this.btnMenu = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Menü konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Menü konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Menü konumu "Alt" olarak seçildi.');
                            break;
                    }
                } else if (item === 'galeri') {
                    this.drawerGaleriKonum = false;
                    this.btnGaleri = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Galeri konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Galeri konumu "Dikey,Büyük" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Galeri konumu "Yatay,Küçük" olarak seçildi.');
                            break;
                    }
                }
            }

        }
    }

    function htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    function strip_html_tags(str) {
        str = str.replace(/&nbsp;/gi, '');
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    }
    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
    function randomText(length) {
        var today = new Date();
        var yil = today.getFullYear();
        var ay = (today.getMonth() + 1);
        var gun = today.getDate();
        let bugun = yil + '' + (ay <= 9 ? '0' + ay : ay) + '' + (gun <= 9 ? '0' + gun : gun);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }

    function updateList(self, type, durum, name) {
        var item = {
            type: type,
            value: [{
                durum: durum,
                [type]: name
            }]
        };
        self.updateData.push(item);
    }
</script>

<style scoped>
    .el-tag + .el-tag {
        margin-left: 10px;
    }

    .yanForm .card {
        margin-top: 10px;
    }

</style>